import './Drawer.css';
export var DrawerBackdropCSS = '_14971977-3-8-0';
export var DrawerCSS = '_14971970-3-8-0';
export var DrawerContentCSS = '_14971978-3-8-0';
export var DrawerPlacementCSS = {left:'_14971971-3-8-0',right:'_14971972-3-8-0'};
export var DrawerWidthStyles = {narrow:'_14971973-3-8-0',medium:'_14971974-3-8-0',wide:'_14971975-3-8-0',full:'_14971976-3-8-0'};